import React from "react";
import { graphql } from "gatsby";

import theme from "../constants/theme";

import Layout from "../components/layout";
import SEO from "../components/seo";

import { SubHeader, StandOutSection, CenterImageSection, CTASection } from "../components/blocks";

export default function techPageTemplate(props) {
  const siteMetaData = props.data.site.siteMetadata;
  const siteData = props.data.allSanitySiteConfig.edges[0].node;
  const sharedData = props.data.allSanitySharedSections.edges[0].node;
  const pageData = props.data.allSanityWhatTechPage.edges[0].node;

  return (
    <Layout
      locale={props.pageContext.locale}
      siteMetaData={siteMetaData}
      mainNav={siteData.mainNav}
      alternateNav={siteData.alternateNav}>
      <SEO title={pageData.pageTitle?.localized} />
      <SubHeader
        title={pageData.header?.title?.localized}
        subTitle={pageData.header?.description?.localized}
      />
      <StandOutSection
        title={pageData.textBlockSection1?.leadText?.title?.localized}
        descriptionRichText={pageData.textBlockSection1?.leadText?.descriptionRichText ?? {}}
        coverImageUrl={pageData.textBlockSection1?.mainImage?.asset?.fluid?.src}
        backgroundColor={theme.colorsTw.bg_bg2}
      />
      <StandOutSection
        title={pageData.textBlockSection2?.leadText?.title?.localized}
        descriptionRichText={pageData.textBlockSection2?.leadText?.descriptionRichText ?? {}}
        coverImageUrl={pageData.textBlockSection2?.mainImage?.asset?.fluid?.src}
        backgroundColor={theme.colorsTw.bg_bg1}
        isFlipped={true}
      />
      <CenterImageSection
        title={pageData.diagramSection2?.leadText?.title?.localized}
        descriptionRichText={pageData.diagramSection2?.leadText?.descriptionRichText ?? {}}
        coverImageUrl={pageData.diagramSection2?.mainImage?.asset?.fluid?.src}
        backgroundColor={theme.colorsTw.bg_bg2}
      />
      <CTASection
        title={sharedData.callToActionSection?.title?.localized}
        description={sharedData.callToActionSection?.description?.localized}
        callToActionTitle={sharedData.callToActionSection?.callToAction?.linkTitle?.localized}
        callToActionRoute={sharedData.callToActionSection?.callToAction?.route?.slug?.current}
      />
    </Layout>
  );
}

import * as _ from "./fragments";

export const query = graphql`
  query($locale: String) {
    # Site Meta Data
    site {
      ...SiteMetaData
    }
    # Site
    allSanitySiteConfig {
      edges {
        node {
          ...MainNav
          ...AlternateNav
        }
      }
    }
    # Shared
    allSanitySharedSections {
      edges {
        node {
          ...CallToActionSection
        }
      }
    }
    # Page
    allSanityWhatTechPage {
      edges {
        node {
          pageTitle {
            localized(locale: $locale)
          }
          header {
            ...SubHeader
          }
          textBlockSection1 {
            ...TextBlockSection
          }
          textBlockSection2 {
            ...TextBlockSection
          }
          diagramSection2 {
            ...TextBlockSection
          }
        }
      }
    }
  }
`;
